import Vue from "vue";
import Router from "vue-router";
import dashboardRoutes from "@/modules/dashboard/routes";
import authRoutes from "@/modules/auth/routes";
import Splash from "@/views/splash/Splash";
import { EServices } from "./types";
import { inject, singleton } from "tsyringe";
import StoreService from "./store";

Vue.use(Router);

@singleton()
export default class AppRouter extends Router {
  constructor(@inject(EServices.store) private store: StoreService) {
    super({
      mode: "history",
      base: "",
      routes: [
        {
          path: "/",
          component: Splash,
        },
        ...authRoutes,
        ...dashboardRoutes,
      ],
      scrollBehavior: (to, from, savedPosition) => {
        return { x: 0, y: 0 };
      },
    });

    this.beforeEach((to, from, next) => {
      const pageTitle = `Jackocoins - ${(to.meta && to.meta.title) || ""}`;
      document.title = pageTitle;
      const requiresAuth = to.matched.some(
        (record) => record.meta.requiresAuth
      );
      if (!requiresAuth) next();
      else if (this.store.state.AccountModule.account == undefined)
        next("/login");
      else if (
        !this.store.state.AccountModule.account.role.permissions.find(
          (permission) => permission.name === "login.app"
        )
      ) {
        next("/login");
        toast({
          icon: "mdi-exclamation-thick",
          iconColor: "red",
          message: "You are not authorized to access this site",
        });
      } else next();
    });
  }
}
